import ChangeProfilePicture from "./ChangeProfilePicture"
import DeleteAccount from "./DeleteAccount"
import EditProfile from "./EditProfile"
import UpdatePassword from "./UpdatePassword"

export default function Settings() {
  return (
    <>
      <h1 className="mb-8 text-2xl md:text-3xl font-medium text-richblack-5">
        Edit Profile
      </h1>
      <div className="flex flex-col gap-6">
        {/* Change Profile Picture */}
        <ChangeProfilePicture />

        {/* Profile */}
        <EditProfile />

        {/* Password */}
        <UpdatePassword />

        {/* Delete Account */}
        <DeleteAccount />
      </div>
    </>
  )
}
